import { render } from "./normal-list.vue?vue&type=template&id=31ece638&scoped=true"
import script from "./normal-list.vue?vue&type=script&lang=js"
export * from "./normal-list.vue?vue&type=script&lang=js"

import "./normal-list.vue?vue&type=style&index=0&id=31ece638&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ece638"]])

export default __exports__